export const QUESTION_TYPES = {
  QUIZ: "QUIZ",
  FILL: "FILL",
};
